module.exports = __webpack_public_path__ + "static/img/icon_point.5156b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/icon_point.png
// module id = 649
// module chunks = 2